import React, { useEffect, useState } from "react";
import URLs from "constants/urls";
import MonthlyOverView from "./monthlyOverView";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
export default function DsaMonthEnd() {
  return (
    <DashboardLayout>
      <MonthlyOverView url={URLs.dsaMonthEndUrl} isItByDsa={true} />
    </DashboardLayout>
  );
}
